import { render } from "./splittedDate.vue?vue&type=template&id=262de024&ts=true"
import script from "./splittedDate.vue?vue&type=script&lang=ts"
export * from "./splittedDate.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\fpbillions\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__